module.exports = __webpack_public_path__ + "img/side-icon-42-off.11d8735d.svg";